import { FC, Fragment, useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Props {
  password: string;
  passwordConfirmation: string;
}
const MatchingPasswordValidation: FC<Props> = ({
  password,
  passwordConfirmation,
}) => {
  const [doPasswordsMatch, setPasswordsMatch] = useState<boolean>(false);
  const theme = useTheme();
  useEffect(() => {
    setPasswordsMatch(password === passwordConfirmation);
  }, [password, passwordConfirmation]);

  const correctStateStyles = {
    color: theme.palette.success.main,
  };
  const errorStateStyles = {
    color: theme.palette.error.main,
  };

  return (
    <Fragment>
      {doPasswordsMatch && (
        <DoneIcon
          sx={{
            color: theme.palette.success.main,
            transform: 'scale(0.5)',
            marginTop: '-0.2rem',
          }}
        />
      )}
      {!doPasswordsMatch && (
        <CloseIcon
          sx={{
            color: theme.palette.error.main,
            transform: 'scale(0.6)',
            marginTop: '-0.2rem',
          }}
        />
      )}
      <Typography
        sx={doPasswordsMatch ? correctStateStyles : errorStateStyles}
        variant="caption"
      >
        Passwords {!doPasswordsMatch && 'must '} match
      </Typography>
    </Fragment>
  );
};

export default MatchingPasswordValidation;
